import createDuck, { createAction, createThunk } from "../utils/actions";
import axios from "../net/axios";
import config from "../config";
let baseUrl = config.api.baseUrl;
const newActions = {
  test: (name) => createAction("NAME", name),
};

const newReducers = {
  NAME: (state, action) => {
    const nState = { data: action.payload, loading: false, error: null };
    return { ...state, ...nState };
  },
};

const duck = createDuck("RESERVAS_BY_LOCAL", newActions, newReducers);

const reservasByLocalThunk = (
  id,
  page,
  limit,
  servicio,
  fechaInicio,
  fechaFin
) => {

  let url = null;
  if (fechaInicio && fechaFin && servicio) {
    url = `${baseUrl}/getReservasByLocal/${id}?page=${page}&limit=${limit}&fechaInicio=${fechaInicio}&fechaFin=${fechaFin}&servicio=${servicio}`;
  } else if (fechaInicio && fechaFin) {
    url = `${baseUrl}/getReservasByLocal/${id}?page=${page}&limit=${limit}&fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`;
  } else if (servicio) {
    url = `${baseUrl}/getReservasByLocal/${id}?page=${page}&limit=${limit}&servicio=${servicio}`;
  } else {
    url = `${baseUrl}/getReservasByLocal/${id}?page=${page}&limit=${limit}`;
  }
  return createThunk(axios, "get", duck.actions, url, null);
};

const cancelarReservaDuck = createDuck(
  "CANCELAR_RESERVA",
  newActions,
  newReducers
);

const cancelarReservaThunk = (reserva) => {

  const url = `${baseUrl}/cancelarReserva`;
  const data = reserva;
  return createThunk(axios, "post", cancelarReservaDuck.actions, url, data);
};

const reservasConfirmadasByLocalDuck = createDuck(
  "GET_RESERVAS_BY_LOCAL",
  newActions,
  newReducers
);

const getReservasByLocalThunk = (reservaId, localId, fechaInicio, fechaLimite, page = null, limit = null, profesionalId = null, servicioId = null, ambienteId = null) => {

  const url = `${baseUrl}/getReservasConfirmadasByLocal`;
  const data = {
    reservaId,
    id: localId,
    fechaInicio: fechaInicio,
    fechaLimite: fechaLimite,
    page,
    limit,
    profesionalId,
    servicioId,
    ambienteId
  };

  return createThunk(
    axios,
    "post",
    reservasConfirmadasByLocalDuck.actions,
    url,
    data
  );
};

const primerDiaDisponibleDuck = createDuck(
  "GET_PRIMER_DIA",
  newActions,
  newReducers
);

const getPrimerDiaDisponibleThunk = (
  month,
  year,
  profesionalId,
  servicioId,
  categoriaId
) => {

  const url = `${baseUrl}/getPrimerDiaDisponible`;
  const data = {
    month,
    year,
    profesionalId,
    servicioId,
    categoriaId,
  };
  return createThunk(axios, "post", primerDiaDisponibleDuck.actions, url, data);
};

const horariosEntreFechasDuck = createDuck(
  "GET_HORARIOS_ENTRE_FECHAS",
  newActions,
  newReducers
);

const getHorariosEntreFechasThunk = (
  fechaIni,
  fechaFin,
  profesionalId,
  servicioId,
) => {
  const url = `${baseUrl}/getHorariosReservar/${fechaIni}/${fechaFin}/${profesionalId}/${servicioId}?incluyeAusencias=true`;

  return createThunk(axios, "get", horariosEntreFechasDuck.actions, url, null);
};

const generarReservasDuck = createDuck(
  "GENERAR_RESERVAS",
  newActions,
  newReducers
);

const generarReservasThunk = (data) => {

  const url = `${baseUrl}/generarReservas`;

  return createThunk(axios, "post", generarReservasDuck.actions, url, data);
};

const getAmbientesDuck = createDuck('GET_AMBIENTES_GENERADOS', newActions, newReducers);

const getAmbientesEntreFechasThunk = (fechaIni, fechaFin, servicioId) => {

  const url = `${baseUrl}/getAmbientesEntreFechas/${fechaIni}/${fechaFin}/${servicioId}`;

  return createThunk(axios, 'get', getAmbientesDuck.actions, url, null);
};


const getReservasObsoletasDuck = createDuck(
  "RESERVAS_OBSOLETAS",
  newActions,
  newReducers
);

const getReservasObsoletasThunk = (data) => {

  const url = `${baseUrl}/getReservasConHorariosObsoletosByLocal`;

  return createThunk(axios, "post", getReservasObsoletasDuck.actions, url, data);
};

const reservasALaParDuck = createDuck(
  "GET_RESERVAS_A_LA_PAR",
  newActions,
  newReducers
);

const getReservasALaParThunk = (reservaId, horarioId, localId) => {
  const url = `${baseUrl}/getReservasALaPar`;
  const data = {
    reservaId,
    horarioId,
    localId,
  };

  return createThunk(
    axios,
    "post",
    reservasALaParDuck.actions,
    url,
    data
  );
};

const addComentarioInternoDuck = createDuck(
  "COMENTARIO_INTERNO",
  newActions,
  newReducers
);

const addNroMesaDuck = createDuck(
  "NRO MESA",
  newActions,
  newReducers
);


const addCometnarioInternoThunk = (data) => {

  const url = `${baseUrl}/updateComentarioInternoReserva`;

  return createThunk(axios, "post", addComentarioInternoDuck.actions, url, data);
};

const addNroMesaThunk = (data) => {

  const url = `${baseUrl}/updateNroMesaReserva`;

  return createThunk(axios, "post", addNroMesaDuck.actions, url, data);
};

const reservasEnDiaDuck = createDuck(
  "GET_RESERVAS_A_LA_PAR",
  newActions,
  newReducers
);

const reservasEnDiaThunk = (localId, inicio) => {
  console.log({ localId, inicio })
  const url = `${baseUrl}/getReservasByLocalOnDay`;
  const data = {
    localId,
    inicio
  };

  return createThunk(
    axios,
    "post",
    reservasEnDiaDuck.actions,
    url,
    data
  );
};



const exp = {
  duck,
  reservasByLocalThunk,
  cancelarReservaDuck,
  cancelarReservaThunk,
  reservasConfirmadasByLocalDuck,
  getReservasByLocalThunk,
  primerDiaDisponibleDuck,
  getPrimerDiaDisponibleThunk,
  horariosEntreFechasDuck,
  getHorariosEntreFechasThunk,
  generarReservasDuck,
  generarReservasThunk,
  getAmbientesDuck,
  getAmbientesEntreFechasThunk,
  getReservasObsoletasDuck,
  getReservasObsoletasThunk,
  reservasALaParDuck,
  getReservasALaParThunk,
  addComentarioInternoDuck,
  addCometnarioInternoThunk,
  reservasEnDiaDuck,
  reservasEnDiaThunk,
  addNroMesaDuck,
  addNroMesaThunk,
};

export default exp;
